import React, { useState } from 'react'
import { BellRinging, Handbag, Heart, ShoppingCartSimple } from '@phosphor-icons/react'

import UseWindowSize from '@components/helpers/UseWindowSize'
import { StoreContext } from "@context/StoreContext"
import NotifyMeModal from '@components/modal/NotifyMeModal'
import { trimStorefrontId, productFormattedPrice } from "@utils"
import { sendAddToCartGAEvent } from '@utils/analytics/analytics'
import { GA_EVENTS } from '@utils/analytics/constants'

const ShopButtons = ({data, size, variants = [], stickyMode = false, hideProductDetails = false, price, showWishListIcon = false, isFreebie = false}) => {
    const { addVariantToCart, buyNow, loading, checkout } = React.useContext(StoreContext)
    const productNameVariant = data?.title?.split(" / ")
    const { width } = UseWindowSize()
    const [openNotifyModal, setOpenNotifyModal] = useState(false)

    const handleBuyNow = () => {
        buyNow(size?.id, 1)
    }

    const handleAddToBag = async () => {
		const cartData = await addVariantToCart(size?.id, 1)
		if (cartData) sendAddToCartGAEvent(GA_EVENTS.ADD_TO_CART, size, cartData)
    }

    const hasComingSoon = data?.collections?.some(collection => collection?.handle === "coming-soon");

    return (
        <React.Fragment>
            
                    <div
                        className={`bg-[#FAFAFA] w-full h-auto lg:h-20 ${
                            !stickyMode
                            ? "relative lg:h-auto pt-10 pb-5 z-10"
                            : `flex justify-center fixed bottom-0 lg:top-0 left-0 bg-white z-[52] ${width > 768 ? 'shadow-lg' : 'drop-shadow-top-sm'}`
                        }`}
                    >
                        <div className="max-container w-full m-0 px-4 py-4 lg:py-2">
                            <div className="w-full flex flex-grow flex-nowrap justify-between items-center gap-x-8">
                                {(stickyMode && !hideProductDetails) && (
                                    <div className={`flex flex-nowrap md:hidden lg:flex lg:flex-1 gap-x-4 justify-start`}>
                                        <img
                                            className="h-16 w-16 rounded-md object-cover"
                                            src={data?.featuredImage?.src}
                                            alt={data?.title}
                                            loading='lazy'
                                        />
                                        <div className='my-auto'>
                                            <h3>{productNameVariant?.[0]?.replace("FINAL SALE", "")}</h3>
                                            <h4>{productNameVariant?.[1]?.replace("FINAL SALE", "")}</h4>
                                        </div>
                                    </div>
                                )}
                                <div className={`flex flex-wrap md:flex-nowrap justify-between gap-4 flex-1 ${!stickyMode && 'px-4'}`}>
									{
										// size?.availableForSale === true && !hasComingSoon && !isFreebie	 
                                        size?.availableForSale === true && !hasComingSoon && !isFreebie ? <>
                                            <button
                                                className={`flex btn-primary items-center justify-center gap-x-3 sm:flex-grow md:flex-1 w-full lg:w-auto ${trimStorefrontId(size?.id, "pid-")}`}
                                                onClick={() => handleBuyNow()}
                                                disabled={loading || (!size?.availableForSale && !hasComingSoon)}
                                                aria-label={'Buy Now'}
                                                data-pid={trimStorefrontId(size?.id, "pid-")}
                                            >
                                                <ShoppingCartSimple size={32} weight="light" />
                                                <span>Buy Now</span>
                                                <span className='block md:hidden lg:block'>•</span>
                                                <span className='block md:hidden lg:block'>
                                                    {
                                                        checkout?.cost?.totalAmount?.currencyCode ?
                                                            productFormattedPrice(
                                                                checkout?.cost?.totalAmount?.currencyCode,
                                                                price
                                                            )
                                                            : null
                                                    }</span>
                                            </button>
                                            <button
                                                className={`flex btn-outline-primary items-center justify-center gap-x-3 flex-1 border-gray-400 text-[#464646] ${trimStorefrontId(size?.id, "pid-")} disabled:opacity-50 disabled:pointer-events-none`}
                                                onClick={() => handleAddToBag()}
                                                disabled={loading || (!size?.availableForSale && !hasComingSoon)}
                                                aria-label={"Add To Bag"}
                                                data-pid={trimStorefrontId(size?.id, "pid-")}
                                            >
                                                <Handbag size={32} weight="light" />
                                                <span>Add To Bag</span>
                                            </button>
                                            {/*showWishListIcon && (
                                                <button
                                                    className={`flex md:hidden lg:flex btn-outline-primary items-center justify-center gap-x-3 border-gray-400 text-[#464646] shrink-0`}
                                                    onClick={() => handleAddToWishList()}
                                                    disabled={loading}
                                                    aria-label="Add To Wishlist"
                                                >
                                                    <Heart size={32} weight="light" />
                                                </button>
                                            )*/}
                                        </> : <>
											{hasComingSoon && !isFreebie ? (
												<div className={`w-full`}>
													<div className='w-full btn-outline !text-[#3D3D3D] flex gap-2 justify-center items-center'>
														<span>Coming Soon</span>
													</div>
												</div>
											) : !isFreebie && (
												<div className={`w-full`}>
													<button className='w-full btn-outline text-primary flex gap-2 justify-center items-center' onClick={() => {setOpenNotifyModal(true)}}>
														<BellRinging size={20} weight='light' /> 
														<span>Notify me when available</span>
													</button>
												</div>	
											)
										}
                                        </>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <NotifyMeModal
                        productName={productNameVariant}
                        isOpen={openNotifyModal}
                        size={size}
                        notifySizes={variants?.filter(item => item?.quantityAvailable <= 0)}
                        onClose={() => setOpenNotifyModal(false)}
                        product_id={data?.shopifyId}
                    />
        </React.Fragment>
    );
}

export default ShopButtons